export default {
    namespaced: true,
    state: {
        goods:[],   // 商家编码
        spuId:[],   // SPUID
    },
    mutations: {
      setGoods (state, goods) {
        state.goods = goods
      },
      setSupID (state, spuId) {
        state.spuId = spuId
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/localsearchdata.js